// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import TRTCCalling from 'trtc-calling-js';
import TIM from 'tim-js-sdk';

let sdkConfig = getSDKAppID();

Vue.config.productionTip = false;
Vue.prototype.$trtcCalling = sdkConfig ? new TRTCCalling({SDKAppID:sdkConfig.appId}) : null;
Vue.prototype.$tim = sdkConfig ? TIM.create({SDKAppID:sdkConfig.appId}) : null;
Vue.prototype.TRTCCalling = TRTCCalling;
Vue.prototype.TIM = TIM;

import {MessageBox, Message, Loading, Button,} from 'element-ui';
import {getSDKAppID} from "./util/call";

Vue.use(Loading);
Vue.use(Button);
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js